const wizardStepTitles = {
  1: "Datele companiei",
  2: "Date de contact",
  3: "Responsabil curier",
  4: "Detalii bancare",
  5: "Valoarea contractului",
  6: "Semnează contractul"
};

export default wizardStepTitles;